enum Key {
	z = 'z',
	k = 'k',
	Backspace = 'Backspace',
}

export default Key;
